import * as utils from "./utils";
import { ICalendarStorage } from "../models/storage";
import { STORAGE_KEYS } from "./constants";

/**
 * Gibt einen Wert aus dem LocalStorage zurück.
 * @param key Der Key des LocalStorage Eintrags.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert ist.
 */
export function get<T>(key: string, isBase64: boolean = false): T
{
    var value: string = localStorage.getItem(key);
    if (value == null)
        return null;

    if (isBase64)
    {
        value = atob(value);
    }

    return utils.parseValue<T>(value);
}

/**
 * Gibt ein JSON-Objekt aus dem LocalStorage zurück.
 * @param key Der Key des LocalStorage Eintrags.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert ist.
 */
export function getJSON<T>(key: string, isBase64: boolean = false): T
{
    var value: string = localStorage.getItem(key);
    if (value == null)
        return null;

    if (isBase64)
    {
        value = atob(value);
    }

    return <T>JSON.parse(value);
}

/**
 * Speichert den übergebenen Wert im LocalStorage ab.
 * @param key Der Key für den Eintrag.
 * @param value Der Wert der gespeichert werden soll.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert werden soll.
 */
export function set(key: string, value: string, isBase64: boolean = false)
{
    value = isBase64 ? btoa(value) : value;
    localStorage.setItem(key, value);
}

/**
 * Speichert den übergebenen Wert im LocalStorage ab.
 * @param key Der Key für den Eintrag.
 * @param value Der Wert der gespeichert werden soll.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert werden soll.
 */
export function setJSON(key: string, value: any, isBase64: boolean = false)
{
    value = isBase64 ? btoa(JSON.stringify(value)) : JSON.stringify(value);
    localStorage.setItem(key, value);
}

/**
 * Speichert folgende Infos im Local Storage ab.
 * - Wie viele Datepicker werden angezeigt?
 * - Ist die SideBar offen oder zu?
 * - Welches Objekt zuletzt selektiert war.
 * - Welches Datum zuletzt selektiert war.
 * - Welche Kalenderansicht zuletzt ausgewählt war.
 */
export function saveCalendarTempData(data: ICalendarStorage)
{
    var storage = getJSON<ICalendarStorage>(STORAGE_KEYS.calendar, true);

    if (storage != null)
    {
        if (data.visibleDatepickerCount != null)
            storage.visibleDatepickerCount = data.visibleDatepickerCount;

        if (data.isSideBarOpen != null)
            storage.isSideBarOpen = data.isSideBarOpen;

        if (data.selectedObject != null)
            storage.selectedObject = data.selectedObject;

        if (data.selectedDate != null)
            storage.selectedDate = data.selectedDate;

        if (data.viewMode != null)
            storage.viewMode = data.viewMode;

        if (data.selected != null)
            storage.selected = data.selected;

        if (data.timeScale != null)
            storage.timeScale = data.timeScale;

        setJSON(STORAGE_KEYS.calendar, storage, true);
    }
    else
    {
        setJSON(STORAGE_KEYS.calendar, data, true);
    }
}